//region :: Imports ::
import React, {ReactElement, ReactNode} from 'react';
import MComponent from '../../Toolkit/Components/Component';
import {MCancelIconName, MSuccessIconName, MIcon} from '../../Toolkit/Icons';
import {DialogPositionType} from 'primereact/dialog';
import Dialog from '../../Toolkit/Components/Controls/Dialog';
import MButton from '../../Toolkit/Components/Controls/Button';
import {FileIconName} from '../SafeDigConstants';

//endregion

/** */
type Props = {
    onDialogClose: () => void;
}

/** */
type State = {
    position?: DialogPositionType;
    visible: boolean;
    data: ReleaseData;
}

export type ReleaseData = {
    estimate: string | undefined;
}

/** */
class CancelDialog extends MComponent<Props, State> {

    private FileIcon: MIcon = {name: FileIconName, color: 'mcolor-info'};

    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();
        this.initializeState();
    }

    /** */
    private bindMethods(): void {
        this.dialog_onHide = this.dialog_onHide.bind(this);

        this.getDialogTemplate = this.getDialogTemplate.bind(this);
        this.getFooterTemplate = this.getFooterTemplate.bind(this);
        this.yes_Click = this.yes_Click.bind(this);
        this.close_Click = this.close_Click.bind(this);

        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
    }

    /** */
    private initializeState(): void {
        this.state = {
            visible: false,
            data: {
                estimate: ''
            }
        };
    }

    /** */
    private dialog_onHide(): void {
        this.safeSetState((draft: State) => draft.visible = false);
    }

    /** */
    public show(estimate: string, position?: DialogPositionType) {

        this.safeSetState((draft: State) => {
            draft.position = position;
            draft.visible = true;
            draft.data.estimate = estimate;
        });

    }

    private yes_Click() {
        this.props.onDialogClose();
        this.hide();
    }

    private close_Click() {
        this.hide();
    }

    private hide() {
        this.safeSetState((draft: State) => {
            draft.visible = false;
        });
    }

    private getDialogTemplate(): ReactNode {
        return (
            <div>
                <p>
                    This will cancel job {this.state.data.estimate}.
                </p>
                <br/>
                {'Are you sure?'}
            </div>
        );
    }

    private getFooterTemplate(): ReactNode {
        return (
            <React.Fragment>
                <MButton label="Yes"
                         icon={MSuccessIconName}
                         disabled={false}
                         onClick={this.yes_Click}/>
                <MButton label="Close"
                         icon={MCancelIconName}
                         disabled={false}
                         onClick={this.close_Click}/>
            </React.Fragment>
        );
    }

    /** */
    public render(): ReactElement {

        return (
            <Dialog title={'Job Cancel'}
                    content={this.getDialogTemplate()}
                    icon={this.FileIcon}
                    footer={this.getFooterTemplate()}
                    position={this.state.position}
                    canClose={false}
                    closeOnEscape={false}
                    visible={this.state.visible}
                    onHide={this.dialog_onHide}/>
        );

    }

}

export default CancelDialog;
